import IVincularCNPJRequest from '../entities/VincularCNPJRequest'
import { IUserRepository } from '../repositories/IUserRepository'

export interface IVincularCNPJ {
  execute(params: IVincularCNPJRequest): Promise<void>
}

export default class VincularCNPJImpl implements IVincularCNPJ {
  constructor(private readonly userRepository: IUserRepository) {}

  public async execute(params: IVincularCNPJRequest): Promise<void> {
    await this.userRepository.vincularCnpj(params)
  }
}
